module.exports = __webpack_public_path__ + "img/cn-pro-3.27102a55.png";